<template>
     <div class="experience">
        <!-- <div class="heading2-section">
            Work Experience
        </div> -->
    <form>
        <div class="mb-3">
    <label class="form-label">Position</label>
    <input type="text" v-model="work.position" placeholder="Previous / Current Position" class="form-control">
    </div>
       <div class="mb-3">
    <label class="form-label">Organization</label>
    <input type="text"  v-model="work.company" placeholder="Name of Organization" class="form-control">
    </div>
    
    <div class="mb-3">
        <label class="form-label">Location</label>
        <input type="text" v-model="work.location" placeholder="City, Country" class="form-control">
    </div>
   
    <div class="mb-3">
        <label class="form-label">Working Since</label>
       <div class="select-dates">
        <div class="select-date">
            <!-- start month -->
            <select class="form-select"  v-model="dates.startMonth" id="monthSelect">
                <!-- <option selected disabled>Select Month</option> -->
                <option>January</option>
                <option>February</option>
                <option>March</option>
                <option>April</option>
                <option>May</option>
                <option>June</option>
                <option>July</option>
                <option>August</option>
                <option>September</option>
                <option>October</option>
                <option>November</option>
                <option>December</option>
            </select>
            <!-- start year -->
              <select class="form-select" v-model="dates.startYear" id="yearSelect">
                <!-- <option selected disabled>Select Year</option> -->
                <option v-for="year in years" :key="year">{{ year }}</option>
            </select>
        </div>
        <!-- to -->
         <div class="to">To</div>

         <div class="select-date">
            <!-- start month -->
            <select class="form-select" @change="updateEndDate"  v-model="dates.endMonth" id="monthSelect">
                <option selected disabled>Select Month</option>
                <option>January</option>
                <option>February</option>
                <option>March</option>
                <option>April</option>
                <option>May</option>
                <option>June</option>
                <option>July</option>
                <option>August</option>
                <option>September</option>
                <option>October</option>
                <option>November</option>
                <option>December</option>
            </select>
            <!-- start year -->
              <select class="form-select" @change="updateEndDate" v-model="dates.endYear" id="yearSelect">
                <!-- <option selected disabled>Select Year</option> -->
                <option v-for="year in years" :key="year">{{ year }}</option>
            </select>
            
        </div>
         

       </div>
    </div>

     <div class="mb-3">
                <div class="form-check">
        <input class="form-check-input" type="checkbox" 
        v-model="currentlyWorking"
        @change="changeEndDate"
        id="checkDefault">
        <label class="form-check-label" for="checkDefault">
            I currently work here
        </label>
                </div>
    </div>

    <div class="form-floating mt-6">
            <div ref="editor" class="custom-quill"></div>
        </div>
        
        <div class="form-buttons mb-3">
            <div class="button-subgroup" v-if="isAdding">
                <button type="submit" class="btn btn-default primary-btn" v-if="loading && buttonClicked" disabled>Adding Experience...</button>
                <button type="submit" class="btn btn-default primary-btn" @click.prevent="addExperience()" v-else>Add Experience</button>
            </div>
            <div class="button-subgroup" v-else>
                <button type="submit" class="btn btn-default primary-btn" v-if="loading && buttonClicked" disabled>Updating Experience...</button>
                <button type="submit" class="btn btn-default primary-btn" @click.prevent="editExperience()" v-else>Update Experience</button>
                <button type="submit" class="btn btn-default primary-btn badge-cancel"v-if="!loading && !buttonClicked" @click.prevent="cancel()">Cancel Edit</button>
            </div>
        </div>
        <!-- errors -->
        <div class="errors" v-if="hasErrors">
            <div class="error" v-for="error in errors">{{ error }}</div>
        </div>
        <!-- errors --> 
    </form> 
    <LoadingIndicator v-if="loading"/>
    <!-- START history -->
    <div class="history">
        <!-- histories -->
        <div class="hist" v-for="experience in experiences" :key="experience.workId">
            <div class="hist-details">
                <div class="hist-title">{{experience.position}}</div>
                <div class="hist-company">{{experience.company}}</div>
                <div class="hist-date">{{experience.startDate}} - {{experience.endDate}}</div>
            </div>
            <div class="hist-controls">
                <button class="btn btn-default button-primary hist-button" @click.prevent="reviewExperience(experience)" style="--bs-btn-padding-y: .25rem; --bs-btn-padding-x: .5rem; --bs-btn-font-size: .75rem;">Edit</button>
                <button class="btn btn-danger hist-button" :id="experience.workId" @click.prevent="deleteExperience(experience.workId)" style="--bs-btn-padding-y: .25rem; --bs-btn-padding-x: .5rem; --bs-btn-font-size: .75rem;">Delete</button>
            </div>
        </div>
        <!--  -->
    </div>
    <!-- END OF HISTORY -->
    </div>
    <CustomConfirmationMessageModal :title="modal.caption"
            ref="workConfirmModal"
           :body="modal.message"
           :button-label="modalButtonLabel"
           :close-modal="() => closeModal()"
           :modal-id="modalId"/>
    <WarningOptionsModal
            ref="workDelModal"
            :body="this.delModal.body"
            :title="this.delModal.title"
            :close-modal="this.delModal.closeModal"
            :yes-selected="this.delModal.yesSelected"
            :yes-button-label="this.delModal.yesButtonLabel"
            :no-button-label="this.delModal.noButtonLabel"
            :modal-id="this.delModal.modalId"
            loading-button-label="Deleting Work Experience..."
            />
</template>
<script>
    import Quill from 'quill'
    import 'quill/dist/quill.snow.css'
    import { addExperienceAsync,editExperienceAsync,deleteExperienceAsync } from '@/services/cvbuilderService';
    import CustomConfirmationMessageModal from '@/components/modals/CustomConfirmationMessageModal.vue';
    import LoadingIndicator from '@/components/Utility/LoadingIndicator.vue';
    import WarningOptionsModal from '@/components/modals/WarningOptionsModal.vue';
export default {
    components:{
        LoadingIndicator,
        CustomConfirmationMessageModal,
        WarningOptionsModal,
    },
    computed:{
        experiences(){
            var works = this.$store.getters["cvbuilder/getCVInformation"]?.workExperiences || [];
            return works.slice().reverse();
        }
    },
     data() {
    return {
    isAdding: true,
     work:{
                company:"",
                position:"",
                location:"",
                startDate:"",
                endDate:"",
                description:""
            },
        dates:{
            startMonth:"",
            startYear:"",
            endMonth:"",
            endYear:""
        },
        currentlyWorking:false,
        modal:{
                caption:"",
                message:""
            },
        delModal:{
            title:"",
            body:"",
            modalId:"delWork",
            yesButtonLabel:"Delete History",
            noButtonLabel:"Cancel",
            closeModal: null,
            yesSelected: null
        },
         selectedWorkId:"",
            errors:[],
            loading:false,
            buttonClicked:false,
            hasErrors:false,
            modalButtonLabel:'Close',
            modalId:"addWork",
      years: []
    };
  },


  created() {
    const currentYear = new Date().getFullYear();
    for (let y = currentYear; y >= 1980; y--) {
      this.years.push(y);
    }
  },
  mounted(){
    this.setupQuill();
  },
  methods:{
           setupQuill(){
                // Initialize Quill
            this.quill = new Quill(this.$refs.editor, {
            theme: 'snow',
            modules: {
                toolbar: [
                ['bold', 'italic', 'underline'],
                [{ list: 'ordered' }, { list: 'bullet' }],
                ['link']
                ]
            }
            });
            //set present values
            this.quill.root.innerHTML = this.work.description;

            // Listen for changes and update Vue data
            this.quill.on('text-change', () => {
            this.work.description = this.quill.root.innerHTML
            })
    },
        updateEndDate(){
            this.currentlyWorking = false;//when an an actual end value has been selected
        },
        changeEndDate(){
            if(this.currentlyWorking){
                this.dates.endMonth = this.dates.endYear = null;
            }
        },
        shortMonth(month){
            const date = new Date(`${month} 1, 2000`); // dummy day/year
            return date.toLocaleString('en-US', { month: 'short' });
        },
        setIdForDelete(workId){
            this.delModal.title = "Delete Work History",
            this.delModal.body = "Are you sure you want to delete this work history?"
            this.delModal.yesSelected = async() => await this.deleteExperience(workId);
            this.delModal.closeModal = () => this.closeDelModal();
            this.showDelModal();
        },
        async deleteIdFromModalButton(){
            await this.deleteExperience(this.idForDelete);
        },
        updateDeleteButton(id, isDisabled, label){
            let btn = document.getElementById(id);
            btn.disabled = isDisabled;
            btn.innerHTML = label;
            
        },
        resetOnNewDelete(){
                this.loading = true;
                this.hasErrors = false;
                this.errors = [];
        },
        stopOnDeleteError(message){
            this.errors.push(message);
            this.hasErrors = true; 
            this.loading = false;
        },
        async deleteExperience(workId){
            try{
                this.resetOnNewDelete();
                this.updateDeleteButton(workId,true,"Deleting...");
                this.resetOnBadgeSelection();
                var data = await deleteExperienceAsync(workId);
                if(!data.success){
                    throw new Error(data.message, {cause: data.caption})
                }else{
                    this.closeDelModal();
                    this.$store.dispatch("cvbuilder/removeExperience",workId);
                    this.loading = false;
                    this.buttonClicked = false;
                    this.isAdding = true;
                    this.work = {
                                   company:"",
                                    position:"",
                                    location:"",
                                    startDate:"",
                                    endDate:"",
                                    description:""
                                };
                    this.dates = {
                                startMonth:"",
                                startYear:"",
                                endMonth:"",
                                endYear:""
                            };
                }
            }catch(e){
                this.stopOnDeleteError(e.message);             
                this.updateDeleteButton(workId,false,"Delete");
                let message = e.message || "Something went wrong. Please try later";
                // this.errors.push(message);
                this.hasErrors = true;
                this.clearErrors();
                
            }
        },
         async editExperience(){
            try{  
                var result = this.resolveAndValidateDates();
                if (!result) {
                    return; // stop execution, errors are already set
                 }
                 var {startDate, endDate} = result;

                 var body = {
                   company: this.work.company, 
                    position: this.work.position,
                    location: this.work.location,
                    startDate,
                    endDate, 
                    description: this.work.description,
                    workId: this.selectedWorkId
                }
                this.resetOnNewSubmit();   
                var data = await editExperienceAsync(body);
                if(!data.success){
                    if(data.errors){
                   data.errors.forEach((err) => {
                    this.errors.push(err);
                        });
                        this.hasErrors = true;
                        this.buttonClicked = false;
                        this.loading = false;
                        this.clearErrors();
                        return;
                    }
                throw new Error(data.message, {cause: data.caption})
                }else{
                    this.$store.dispatch("cvbuilder/updateExperience", body);
                    this.loading = false;
                    this.buttonClicked = false;
                    this.isAdding = true;
                    this.work = {
                                   company:"",
                                    position:"",
                                    location:"",
                                    startDate:"",
                                    endDate:"",
                                    description:""
                                };
                    this.dates = {
                                startMonth:"",
                                startYear:"",
                                endMonth:"",
                                endYear:""
                            };
                    this.quill.root.innerHTML = "";
                    this.currentlyWorking = false;
                }
            }catch(e){
                this.loading = false;
                this.buttonClicked = false;
                let message = e.message || "Something went wrong. Please try later";
                this.errors.push(message);
                this.hasErrors = true;
                this.clearErrors();
            }
        },
        async addExperience(){
            try{   
                var result = this.resolveAndValidateDates();
                if (!result) {
                    return; // stop execution, errors are already set
                 }
                 var {startDate, endDate} = result;
                var body = {
                    company: this.work.company, 
                    position: this.work.position,
                    location: this.work.location,
                    startDate: startDate,
                    endDate: endDate,
                    description: this.work.description
                }
                this.resetOnNewSubmit();   
                var data = await addExperienceAsync(body);
                if(!data.success){
                    if(data.errors){
                   data.errors.forEach((err) => {
                    this.errors.push(err);
                        });
                        this.hasErrors = true;
                        this.buttonClicked = false;
                        this.loading = false;
                        this.clearErrors();
                        return;
                    }
                throw new Error(data.message, {cause: data.caption})
                }else{
                    this.$store.dispatch("cvbuilder/addNewExperience", data.experience);
                    this.loading = false;
                    this.buttonClicked = false;
                    this.isAdding = true;
                     this.work = {
                                   company:"",
                                    position:"",
                                    location:"",
                                    startDate:"",
                                    endDate:"",
                                    description:""
                                };
                    this.dates = {
                                startMonth:"",
                                startYear:"",
                                endMonth:"",
                                endYear:""
                            };
                    this.quill.root.innerHTML = "";
                    this.currentlyWorking = false;
                }
            }catch(e){
                this.loading = false;
                this.buttonClicked = false;
                let message = e.message || "Something went wrong. Please try later";
                this.errors.push(message);
                this.hasErrors = true;
                this.clearErrors();
            }
        },
        clearFieldsBeforeReview(){
             this.work = {
                                   company:"",
                                    position:"",
                                    location:"",
                                    startDate:"",
                                    endDate:"",
                                    description:""
                                };
                    this.dates = {
                                startMonth:"",
                                startYear:"",
                                endMonth:"",
                                endYear:""
                            };
                    this.quill.root.innerHTML = "";
                    this.currentlyWorking = false;
        },
        reviewExperience(experience){
            this.clearFieldsBeforeReview();

            this.isAdding = false;
            this.work = {
                position: experience.position,
                company: experience.company,
                location: experience.location,
                startDate: "",
                endDate:"",
                description: experience.description
            };
            this.sortDatesForEditing(experience);
             this.quill.root.innerHTML = experience.description;
            this.selectedWorkId = experience.workId
        },
        sortDatesForEditing(experience){
            if(experience.endDate == 'Present'){
                this.currentlyWorking = true;
            }else{
                let endMonth;
                let endYear;
                let endArray = experience.endDate.split(" ");
                endMonth = endArray[0]; //short month
                endYear = endArray[1]// year
                let fullEndMonth = this.parseFullMonth(endMonth);
                this.dates.endMonth = fullEndMonth;
                this.dates.endYear = endYear;
            }

                let startMonth;
                let startYear;
                let startArray = experience.startDate.split(" ");
                startMonth = startArray[0]; //short month
                startYear = startArray[1]// year
                let fullStartMonth = this.parseFullMonth(startMonth);
                this.dates.startMonth = fullStartMonth;
                this.dates.startYear = startYear;
        },
        parseFullMonth(shortMonth){ //default 'January'
            try{
                if(shortMonth.trim().length == 3){
                    const date = new Date(`${shortMonth} 1, 2000`);
                    if(isNaN(date)){ //if invalid date, throw
                        let err = new Error();
                        throw err;
                    }
                    return date.toLocaleString('en-US', { month: 'long' });
                }else{
                    return 'January';
                }
            }catch(e){
                return 'January';
            }
        },
        toggleEndDate(){
        if(!this.currentlyWorking)
            {
            // Checkbox was unchecked - now mark as currently working
                    this.currentlyWorking = true;
                    this.work.endMonth = "Present";
                    this.work.endYear = "";
                }else{
            // Checkbox was checked - now mark as not currently working
                    this.currentlyWorking = false;
                    this.work.endMonth = "";
                    this.work.endYear = "";
            }
        },
        cancel(){
            this.isAdding = true;
            this.work = {
               company:"",
                position:"",
                location:"",
                startDate:"",
                endDate:"",
                description:""
            };
            this.dates = {
                startMonth:"",
                startYear:"",
                endMonth:"",
                endYear:"",
            }
            this.quill.root.innerHTML = "";
            this.currentlyWorking = false;
        },
        closeModal(){
        if (this.$refs.workConfirmModal && typeof this.$refs.workConfirmModal.hide === 'function') {
        this.$refs.workConfirmModal.hide();
        }
        },
        showModal(){
            this.$refs.workConfirmModal.show();
        },
         closeDelModal(){
        if (this.$refs.workDelModal && typeof this.$refs.workDelModal.hide === 'function') {
        this.$refs.workDelModal.hide();
        }
        },
        showDelModal(){
            this.$refs.workDelModal.show();
        },
         resetOnNewSubmit(){
                this.loading = true;
                this.buttonClicked = true;
                this.hasErrors = false;
                this.errors = [];
        },
         resetOnBadgeSelection(){
                this.loading = true;
                //this.buttonClicked = true; //cause no form button is clicked
                this.hasErrors = false;
                this.errors = [];
        },
        resolveAndValidateDates(){
                    var startDate =
                this.dates.startMonth && this.dates.startYear
                    ? `${this.shortMonth(this.dates.startMonth)} ${this.dates.startYear}`
                    : '';

                var endDate = this.currentlyWorking
                ? 'Present'
                : (this.dates.endMonth && this.dates.endYear
                    ? `${this.shortMonth(this.dates.endMonth)} ${this.dates.endYear}`
                    : '');

                // Simple validation
                if (!startDate) {
                    this.errors = ['Please select a valid start month and year.'];
                    this.hasErrors = true;
                    this.clearErrors();
                    return;
                }
                if (!this.currentlyWorking && !endDate) {
                    this.errors = ['Please select a valid end month and year or that you currently work here.'];
                    this.hasErrors = true;
                    this.clearErrors();
                    return;
                }

                return {startDate, endDate}
        },
        clearErrors(){
            setTimeout(() => {
                this.errors = [];
                this.hasErrors = false;
            }, 3000);          
        }
  }


}
</script>
<style scoped>
.select-dates, .select-date{
    display: flex;
    
}

.select-date{
    column-gap:0.5rem;
}

.select-dates{
    row-gap:0.8rem;
    align-items: flex-start;
    flex-direction: column;
}

select{
    min-width:9rem;
}

  .custom-quill.ql-container.ql-snow{
        background-color: var(--editor-background2)!important;
        color:var(--foreground);
    }






@media (max-width:768px) {
    .select-dates{
        flex-direction: column;
        align-items: flex-start;
        row-gap: 0.7rem;
    }
}
</style>